import { Component, OnInit, Input, forwardRef } from '@angular/core';

import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

import * as moment from 'moment';

@Component({

    selector: 'aFormDate,[aFormDate]',
    templateUrl: './aFormDate.component.html',
    styleUrls: ['./aFormDate.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormDateComponent, multi: true },
    ]
})
export class AFormDateComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() icon;
    @Input() disabled;
    value;
    date;
    _onChange = (value: any) => { };

    registerOnChange(fn) {
        
        this._onChange = fn;
    }
    onChangeDate(value: any) {
        if(value == ''){
            this._onChange(null);
        }else{
            let ms;
            let d = new Date(value);
            ms ={
                ms:moment(value).toISOString()
            }
            this.date = d;
            this._onChange(ms);
        }
    };

    registerOnTouched() { }
    writeValue(value: any) {
        if(value  && value.ms){
            let d:Date = new Date(value.ms);
            this.value = d;
             this.onChangeDate(this.value);
        }else{
            this.value = null ;
        }
       
    }

    constructor(public rootService:RootService) { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormDate/aFormDate.component.ts